import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { config } from '@/config'
//import VueInputmask from 'vue-inputmask'

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.instrumentationKey,
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true
  }
})

appInsights.loadAppInsights().trackEvent({ name: 'App Loaded!' })

Vue.config.productionTip = false
//Vue.use(VueInputmask)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')